import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { MobileAppLanding } from './MobileAppLanding.types';

export function useMobileAppLandingData(): Page<MobileAppLanding>['templateFields'] {
  return useCurrentPage<Page<MobileAppLanding>>().templateFields;
}
